import { render, staticRenderFns } from "./TabCardCib.vue?vue&type=template&id=6e2d772d&scoped=true&"
import script from "./TabCardCib.vue?vue&type=script&lang=js&"
export * from "./TabCardCib.vue?vue&type=script&lang=js&"
import style0 from "./TabCardCib.vue?vue&type=style&index=0&id=6e2d772d&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e2d772d",
  null
  
)

export default component.exports